class videoUtils {

    constructor() {

        this.transicriptHeader = document.getElementById('transcript-header');
        this.isModalEnabled = document.body.classList.contains('video-modal');

        //if there is transcript on the page, add toggleVideoTranscript event
        if ( this.transcriptHeader ) {
            this.transcriptText = document.getElementById('transcript-text');
            this.transcriptShow = document.getElementById('transcript-show');
            this.transcriptHide = document.getElementById('transcript-hide');
            this.transcriptHeader.addEventListener('click', this.toggleVideoTranscript.bind(this));
        }


    }
     /**
      *  initialize the video loader
      */
      initVideoLoader() {
        //get global criticalVideoLoader for the first time init
        this.loader = this.loader || window.criticalVideoLoader;

        if (this.loader !== 'undefined') {

            //get video config data.
            let configData = this.loader.getVideoElementsData().map((data) => { return data; });

            if (configData) {
                /**
                 * passing third param true to loadVideos event in criticalVideoLoader.js to indicate that we want to
                 * track page view for the video as soon as it is clicked.
                 */
                this.loader.loadScript(this.loader.loadVideos.bind(this.loader), configData, true);
            }
        }
    }
    /**
     * Set Video Config Object
     * @param {String} releaseURL - Release Url 
     */
    addVideoPlayerElement (releaseURL, endcardFeed, currentUrl, category, pageName, tag) {
        let iu = '/fscom/' + category + '/video';
        let site = 'www.foxsports.com/' + category + '/video';
        let videoConfig = {
            iu: iu,
            categoryName: category,
            siteSection: site,
            isFwEnabled: true,
            hideMeta: false,
            share: true,
            share_embed: true,
            endcard: true,
            endcard_feed: endcardFeed,
            endcard_countdown: true,
            endcard_autoadvance: true,
            releaseURL: releaseURL,
            pageLocation: 'index',
            pageName: pageName,
            tag: tag,
            url: currentUrl
        }

        let videoEl = document.createElement('div');
        videoEl.setAttribute('id', 'video');
        videoEl.setAttribute('class', 'platformPlayer');
        videoEl.setAttribute('data-player-config', JSON.stringify(videoConfig));
        videoEl.setAttribute('enable-pinning', '');
        return videoEl;
    }
    /**
     * Set Video Config Object by using an existing object
     * @param {String} videoPlayerConfig - Video player configuration
     */
    addVideoPlayerElementByConfig(videoPlayerConfig) {

        let videoEl = document.createElement('div');
        videoEl.setAttribute('id', 'video');
        videoEl.setAttribute('class', 'platformPlayer');
        videoEl.setAttribute('data-player-config', videoPlayerConfig);
        videoEl.setAttribute('enable-pinning', '');
        return videoEl;
    }
    /**
     *  Loads the video player
     */
    videoLoader (criticaLoader) {
        let objs = [];
        if (criticaLoader) {
            //get video players of the page. 
            objs = criticaLoader.getVideoElementsData().map((data) => {
                return data;
            });
        }
        if (typeof FDM_Player !== 'undefined') {
            criticaLoader.loadVideos(FDM_Player, objs);
        } else {
            criticaLoader.loadScript(criticaLoader.loadVideos.bind(criticaLoader), objs);
        }
    }

    //wrappers for video pinning
    createPinWrapperEl() {

        let fsPlayer = document.createElement('div');
        let playerWrapper = document.createElement('div');
        fsPlayer.className = "fs-player";
        playerWrapper.className = "platformPlayer-wrapper";

        fsPlayer.appendChild(playerWrapper);

        return fsPlayer;
    }

    /**
     * show and hide the video transcript when user clicks on transcript label or arrows
     */
    toggleVideoTranscript( e ) {
        
        let id = e.target.id;

        if (id === 'transcript-show' || id === 'arrow-down') {
            this.transcriptText.style.display = 'block';
            this.transcriptShow.style.display = 'none';
            this.transcriptHide.style.display = 'block';

        } else if (id === 'transcript-hide' || id === 'arrow-up') {
            this.transcriptText.style.display = 'none';
            this.transcriptShow.style.display = 'block';
            this.transcriptHide.style.display = 'none';
        }
    }
    /**
      * Adds the click listener to article images on section fronts and loads the video player
      */
      loadVideoPlayer(callback) {
        //get all videos on the section front standard/regional
        let isFscPage = document.querySelector('.fsc-page');
        this.videos = document.querySelectorAll('.fs-player');
        if (this.videos) {
            let context = this;
            for (let i = 0, j = this.videos.length; i < j; i++) {
                let video = this.videos[i].parentElement;
                video.addEventListener('click', (e) => {
                    if (e.target.className.indexOf('fb-icon') > -1 || 
                        ( e.target.tagName === "IMG" && e.target.className.indexOf('show') > -1 ) ) return;
                    let link = video.querySelector('a');
                    if(link && link.target === '_blank') return;
                    e.stopPropagation();
                    (e.preventDefault) ? e.preventDefault() : (e.returnValue = false); //ie support
                    callback(video, isFscPage, this.isModalEnabled); 
                });
            }
        }
    }

    /**
     * set video details trigger
     */
    setVideoDetailsToggle(parentEl = document.body){
        let els = parentEl.querySelectorAll('.video-details-toggle');
        for(let i=0, len=els.length; i<len; i++) {
            let el = els[i];
            if( !el.hasAttribute('data-video-details-toggle') ) {
                el.addEventListener('click',this.toggleVideoDetails.bind(this));
                el.setAttribute('data-video-details-toggle','');
            }
        }
    }
    /**
     * show and hide the video details when user clicks on label or arrows
     */
    toggleVideoDetails( e ) {
        let target = e.currentTarget || e.srcElement || e.target;
        let arrow = target.querySelector('[class*="fs-icons"]');
        let content = target.nextSibling;
        do {
            content = content.nextSibling;
        } while(content.classList && !content.classList.contains('video-details-content'));
        let isShown = content.classList.contains('video-details-show') && arrow.classList.contains('fs-icons_arrow_up');

        if (isShown) {
            content.classList.remove('video-details-show');
            arrow.classList.remove('fs-icons_arrow_up');
            content.classList.add('video-details-hide');
            arrow.classList.add('fs-icons_arrow_down');

        } else {
            content.classList.remove('video-details-hide');
            arrow.classList.remove('fs-icons_arrow_down');
            content.classList.add('video-details-show');
            arrow.classList.add('fs-icons_arrow_up');
        }
    }    
}

export default new videoUtils();


// WEBPACK FOOTER //
// ./assets/components/fsUtils/videoUtils.js